import React, { Component } from "react";
import { Alert, Checkbox, Col, Modal, Row, Select, Table, Tag, message } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import moment from "moment";
import "moment/locale/es";
import DatePickerItem from "./DatePickerItem";
import SelectItem from "./SelectItem";
import cuentaMask from "./cuentaMask";
import dineroDisabledMask from "./dineroDisabledMask";

moment.locale("es");

const { Option } = Select;

// Modal para mover las cuentas contables de un Cliente / Proveedor, este o no
// generada ya la cuenta.
//
// El tipo no se toca aqui: el usuario elige a que cuenta contable se va cada rol.
// Como los movimientos historicos se quedan en la cuenta anterior, se le muestra
// exactamente que poliza de traslado se generaria y se le pregunta si la quiere.
// Si dice que no, las cuentas se mueven igual y no se toca la contabilidad.
//
// Solo aplica cuando el tipo genera cuentas por entidad; si las cuentas son
// compartidas por el tipo, el backend responde `permitido: false` con el motivo y
// aqui solo se explica.
const CONFIG = {
  cliente: {
    endpointPrevisualizar: "clientes/previsualizarCambioCuentasCliente",
    endpointMover: "clientes/cambiarCuentasCliente",
    campoId: "clienteId",
    etiqueta: "cliente",
    titulo: "Mover cuentas contables del cliente",
    etiquetaSaldo: "Cuentas por Cobrar",
  },
  proveedor: {
    endpointPrevisualizar: "proveedores/previsualizarCambioCuentasProveedor",
    endpointMover: "proveedores/cambiarCuentasProveedor",
    campoId: "proveedorId",
    etiqueta: "proveedor",
    titulo: "Mover cuentas contables del proveedor",
    etiquetaSaldo: "Cuentas por Pagar",
  },
};

// Referencia estable para que el memo de opciones no se invalide en cada render
// cuando la pagina padre todavia no cargo las cuentas.
const SIN_CUENTAS = [];

const ESTADO_INICIAL = {
  fecha: null,
  cuentas: {},
  previsualizacion: null,
  generarPoliza: true,
  cargando: false,
  guardando: false,
  confirmado: false,
};

class MoverCuentasEntidadModal extends Component {
  state = { ...ESTADO_INICIAL, fecha: moment() };

  get config() {
    return CONFIG[this.props.entidad];
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      const fecha = moment();
      this.setState({ ...ESTADO_INICIAL, fecha });
      // Se pide de entrada para poder mostrar las cuentas actuales y, si el tipo usa
      // cuentas compartidas, el motivo por el que no se puede mover nada.
      this.previsualizar({ cuentas: {}, fecha });
    }
  }

  // Las opciones son las mismas cuentas contables finales que ya carga la pagina;
  // se memorizan por referencia para no rearmar cientos de <Option> en cada tecla.
  opcionesCuentas() {
    const fuente = this.props.cuentasContables || SIN_CUENTAS;
    if (this.fuenteCuentas !== fuente) {
      this.fuenteCuentas = fuente;
      this.opciones = fuente.map((cuenta) => (
        <Option value={cuenta._id} key={cuenta._id}>
          {cuentaMask(
            (cuenta.nivel1 || "") +
              (cuenta.nivel2 || "") +
              (cuenta.nivel3 || "") +
              (cuenta.nivel4 || "") +
              (cuenta.nivel5 || "")
          ) +
            " - " +
            cuenta.descripcion}
        </Option>
      ));
    }
    return this.opciones;
  }

  cerrar(huboCambio, resultado) {
    this.props.onCerrar(huboCambio, resultado);
  }

  // La previsualizacion depende de las cuentas elegidas y de la fecha (que corta el
  // saldo a trasladar), asi que se vuelve a pedir cada vez que cambia cualquiera.
  previsualizar(cambios = {}) {
    const siguiente = { ...this.state, ...cambios };
    const { cuentas, fecha } = siguiente;

    this.setState({ ...cambios, confirmado: false, cargando: true });

    axios
      .post(
        this.config.endpointPrevisualizar,
        {
          empresaId: this.props.empresaId,
          [this.config.campoId]: this.props.entidadId,
          fecha: fecha ? fecha.format("YYYY-MM-DD") : undefined,
          cuentas,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ previsualizacion: res.data, cargando: false });
        } else {
          this.setState({ previsualizacion: null, cargando: false });
          message.error(res.data.message || "No se pudo previsualizar el movimiento.");
        }
      })
      .catch(() => {
        this.setState({ previsualizacion: null, cargando: false });
        message.error("Error de red al previsualizar el movimiento.");
      });
  }

  cambiarCuenta(rol, valor) {
    const cuentas = { ...this.state.cuentas };
    if (valor) cuentas[rol] = valor;
    else delete cuentas[rol];
    this.previsualizar({ cuentas });
  }

  confirmar() {
    const { fecha, cuentas, generarPoliza } = this.state;

    this.setState({ guardando: true });
    axios
      .post(
        this.config.endpointMover,
        {
          empresaId: this.props.empresaId,
          [this.config.campoId]: this.props.entidadId,
          fecha: fecha ? fecha.format("YYYY-MM-DD") : undefined,
          cuentas,
          generarPoliza,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ guardando: false });
        if (res.data.success === 2) {
          if (res.data.folioPoliza) {
            message.success(
              `Se movieron las cuentas y se genero la poliza de traslado ${
                res.data.folioPoliza
              } por ${dineroDisabledMask(res.data.totalTrasladado)}.`
            );
          } else if (res.data.saldoSinTrasladar) {
            message.success(
              `Se movieron las cuentas sin generar poliza: ${dineroDisabledMask(
                res.data.saldoSinTrasladar
              )} se quedaron en las cuentas anteriores.`
            );
          } else {
            message.success("Se movieron las cuentas. No habia saldo que trasladar.");
          }
          this.cerrar(true, res.data);
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se pudieron mover las cuentas.");
        } else {
          message.error(res.data.message || "Hubo un error y las cuentas no se movieron.");
        }
      })
      .catch(() => {
        this.setState({ guardando: false });
        message.error("Error de red al mover las cuentas.");
      });
  }

  columnas() {
    return [
      {
        title: "Cuenta",
        key: "etiqueta",
        width: "16%",
        render: (_, linea) => (
          <span>
            {linea.etiqueta}
            {linea.obligatoria ? (
              <div style={{ fontSize: 11, color: "#666" }}>principal</div>
            ) : null}
          </span>
        ),
      },
      {
        title: "Actual",
        dataIndex: "cuentaOrigen",
        key: "cuentaOrigen",
        width: "27%",
        render: (cuenta) =>
          cuenta ? cuenta.nombre : <span style={{ color: "#999" }}>Sin cuenta</span>,
      },
      {
        title: "Nueva",
        key: "cuentaDestino",
        width: "34%",
        render: (_, linea) => (
          <SelectItem
            width="100%"
            allowClear
            // Sin esto SelectItem salta el foco al siguiente control despues de
            // elegir, y aqui eso brinca de renglon en renglon de la tabla.
            noFocusSiguiente
            placeholder="Sin cambio"
            value={this.state.cuentas[linea.rol]}
            onChange={(valor) => this.cambiarCuenta(linea.rol, valor)}
          >
            {this.opcionesCuentas()}
          </SelectItem>
        ),
      },
      {
        title: `Se debe (${this.config.etiquetaSaldo})`,
        key: "monto",
        width: "23%",
        align: "right",
        render: (_, linea) => {
          if (linea.sinCambio) return <span style={{ color: "#999" }}>—</span>;
          if (!linea.cuentaOrigen) return <Tag>Solo se asigna</Tag>;
          if (!linea.total) return <Tag color="green">Sin saldo</Tag>;
          return (
            <span>
              {dineroDisabledMask(linea.monto)}
              {linea.proyectos > 1 ? (
                <div style={{ fontSize: 11, color: "#666" }}>{linea.proyectos} proyectos</div>
              ) : null}
            </span>
          );
        },
      },
    ];
  }

  // La poliza que se generaria, tal cual: mismo tipo, misma fecha, mismo concepto y
  // los mismos cargos y abonos que crearia el backend.
  renderPoliza(poliza) {
    return (
      <div
        style={{
          marginTop: 16,
          border: "1px solid #e8e8e8",
          borderRadius: 4,
          padding: 12,
        }}
      >
        <div style={{ fontWeight: 600, marginBottom: 8 }}>Poliza que se generaria</div>
        <Row gutter={16} style={{ fontSize: 12, color: "#444", marginBottom: 8 }}>
          <Col span={8}>
            <b>Tipo:</b>{" "}
            {poliza.tipoDePolizaNombre || (
              <span style={{ color: "#cf1322" }}>sin configurar en la empresa</span>
            )}
          </Col>
          <Col span={8}>
            <b>Folio aproximado:</b> {poliza.folioAproximado || "—"}
          </Col>
          <Col span={8}>
            <b>Fecha:</b>{" "}
            {poliza.fecha ? moment(poliza.fecha).format("L") : ""}
          </Col>
          <Col span={16} style={{ marginTop: 4 }}>
            <b>Concepto:</b> {poliza.concepto}
          </Col>
          <Col span={8} style={{ marginTop: 4 }}>
            <b>Proyecto:</b> {poliza.proyecto || "—"}
          </Col>
        </Row>
        <Table
          size="small"
          pagination={false}
          rowKey={(fila, indice) => indice}
          dataSource={poliza.movimientos}
          scroll={{ x: true }}
          columns={[
            {
              title: "Cuenta",
              key: "cuenta",
              render: (_, fila) => fila.cuenta?.nombre || "—",
            },
            { title: "Proyecto", key: "proyecto", render: (_, fila) => fila.proyecto || "—" },
            {
              title: "Cargo",
              key: "cargo",
              align: "right",
              render: (_, fila) => (fila.cargo ? dineroDisabledMask(fila.monto) : ""),
            },
            {
              title: "Abono",
              key: "abono",
              align: "right",
              render: (_, fila) => (fila.cargo ? "" : dineroDisabledMask(fila.monto)),
            },
          ]}
          summary={() => (
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={2}>
                <b>Totales</b>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={2} align="right">
                <b>{dineroDisabledMask(poliza.totalCargos)}</b>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={3} align="right">
                <b>{dineroDisabledMask(poliza.totalAbonos)}</b>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          )}
        />
      </div>
    );
  }

  render() {
    const { previsualizacion, cargando, guardando, confirmado, generarPoliza } = this.state;
    const config = this.config;

    const permitido = previsualizacion ? previsualizacion.permitido !== false : true;
    const totalATrasladar = previsualizacion?.totalATrasladar || 0;
    // Lo dice la previsualizacion, no el estado local: elegir la misma cuenta que ya
    // tiene el renglon no es un cambio, y el backend tambien lo descarta.
    const hayCambios = !!previsualizacion?.lineas?.some((linea) => !linea.sinCambio);
    // El backend solo puede asentar la poliza si tiene tipo de poliza configurado.
    const faltaTipoDePoliza =
      !!previsualizacion?.poliza && !previsualizacion.poliza.tipoDePolizaNombre;

    const puedeGuardar =
      !!previsualizacion &&
      permitido &&
      !cargando &&
      hayCambios &&
      !!this.state.fecha &&
      !(generarPoliza && faltaTipoDePoliza) &&
      (totalATrasladar === 0 || confirmado);

    return (
      <Modal
        title={`${config.titulo}${this.props.nombre ? ` — ${this.props.nombre}` : ""}`}
        visible={this.props.visible}
        width={1000}
        onCancel={() => this.cerrar(false)}
        onOk={() => this.confirmar()}
        okText="Mover cuentas"
        okButtonProps={{ loading: guardando, disabled: !puedeGuardar }}
        cancelText="Cancelar"
        destroyOnClose
      >
        {previsualizacion && !permitido ? (
          <Alert type="warning" showIcon message="No se pueden mover las cuentas aqui" description={previsualizacion.motivo} />
        ) : (
          <>
            <Row gutter={16}>
              <Col span={12}>
                <div style={{ marginBottom: 4 }}>Fecha del traslado</div>
                <DatePickerItem
                  style={{ width: "100%" }}
                  value={this.state.fecha}
                  allowClear={false}
                  onChange={(fecha) => this.previsualizar({ fecha })}
                />
              </Col>
            </Row>

            <Table
              style={{ marginTop: 16 }}
              size="small"
              loading={cargando}
              pagination={false}
              dataSource={previsualizacion?.lineas || []}
              columns={this.columnas()}
              rowKey="rol"
              scroll={{ x: true }}
            />

            {previsualizacion?.poliza ? this.renderPoliza(previsualizacion.poliza) : null}

            {previsualizacion?.avisos?.map((aviso, indice) => (
              <Alert key={indice} style={{ marginTop: 12 }} type="warning" showIcon message={aviso} />
            ))}

            {totalATrasladar > 0 ? (
              <>
                <Checkbox
                  style={{ marginTop: 16 }}
                  checked={generarPoliza}
                  onChange={(e) =>
                    this.setState({ generarPoliza: e.target.checked, confirmado: false })
                  }
                >
                  Generar la poliza de traslado por {dineroDisabledMask(totalATrasladar)}
                </Checkbox>

                {generarPoliza ? (
                  <Alert
                    style={{ marginTop: 12 }}
                    type="info"
                    showIcon
                    message={`El saldo sale de las cuentas actuales y entra a las nuevas con fecha ${
                      this.state.fecha ? this.state.fecha.format("L") : ""
                    }.`}
                    description="Las cuentas anteriores quedan en cero conservando su historico: no se modifica ninguna poliza anterior. Si la fecha cae en un periodo ya declarado, la balanza de ese mes cambiara."
                  />
                ) : (
                  <Alert
                    style={{ marginTop: 12 }}
                    type="warning"
                    showIcon
                    message="Las cuentas se van a mover sin poliza."
                    description={`El saldo de ${dineroDisabledMask(
                      totalATrasladar
                    )} se queda en las cuentas anteriores y las nuevas empiezan en cero, asi que el auxiliar dejara de cuadrar contra ${
                      config.etiquetaSaldo
                    } hasta que lo traslades a mano.`}
                  />
                )}

                {/* Las dos respuestas son una decision contable, no solo el "si": mover
                    las cuentas sin poliza deja el saldo varado. Por eso se confirma en
                    los dos casos. */}
                <Checkbox
                  style={{ marginTop: 12 }}
                  checked={confirmado}
                  onChange={(e) => this.setState({ confirmado: e.target.checked })}
                >
                  {generarPoliza
                    ? "Entiendo que se generara una poliza contable con este traslado de saldos"
                    : "Entiendo que el saldo se queda en las cuentas anteriores y no se generara ninguna poliza"}
                </Checkbox>

                {generarPoliza && faltaTipoDePoliza ? (
                  <Alert
                    style={{ marginTop: 12 }}
                    type="error"
                    showIcon
                    message="La empresa no tiene configurado el tipo de poliza de diario para traspasos entre cuentas."
                    description="Configuralo en la empresa, o desmarca la casilla para mover las cuentas sin generar poliza."
                  />
                ) : null}
              </>
            ) : hayCambios ? (
              <Alert
                style={{ marginTop: 16 }}
                type="success"
                showIcon
                message="No hay saldo que trasladar: solo se cambian las cuentas."
              />
            ) : (
              <Alert
                style={{ marginTop: 16 }}
                type="info"
                showIcon
                message="Elige la cuenta nueva del renglon que quieras mover."
              />
            )}
          </>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(MoverCuentasEntidadModal);
